/* -------------------------------------------------------------------------- */
/*                                   TITLES                                   */
/* -------------------------------------------------------------------------- */
const titles = {
	pbs: "Proxmox Backup Server",
	pbs_sync: "PBS sync",
};

/* -------------------------------------------------------------------------- */
/*                                 SELECT TYPE                                */
/* -------------------------------------------------------------------------- */
const selectType = {
	card_bttn: "Configureer",

	// Products
	pbs_free: {
		description: "150 GB gratis opslag.",
		disabled_info: "Max. 1 per klant",
		title: "Tuxis PBS - Gratis",
	},
	pbs_paid: {
		description: "Volledige versie voor zakelijke toepassing.",
		disabled_info: "Betaalde diensten niet toegestaan",
		title: "Tuxis PBS",
	},
	pbs_sync: {
		description: "Synchroniseer een datastore.",
		disabled_info: "Betaalde diensten niet toegestaan",
		title: "PBS sync",
	},
	price_suffix: "p/m per",
	title: "Welke Proxmox Backup dienst wilt u aanmaken?",
};

/* -------------------------------------------------------------------------- */
/*                                FORM SECTION                                */

const pbsConfigDescription = `
Bepaal een naam en geef aan hoe u gefactureerd wilt worden en wanneer u een notificatie wilt ontvangen. 

**Vast limiet** 
Uw datastore groeit niet automatisch en kan dus vol raken wanneer u niet tijdig vergroot. U kunt notificaties instellen om dit te voorkomen. U krijgt het daadwerkelijk gebruik gefactureerd. Het formaat van de datastore is niet relevant voor facturatie.

**Grow as you go** 
Uw datastore is niet gelimiteerd maar groeit automatisch wanneer deze bijna vol is. U krijgt alleen daadwerkelijk gebruik gefactureerd. Het formaat van de datastore is niet relevant voor facturatie.`;

const pbsResellerDescription =
	"Wanneer je de datastore linkt aan een klant, krijgt deze klant eigen inloggegevens waarmee er ingelogd kan worden op de datastore.\nAls reseller heeft u ook toegang tot deze datastore via uw eigen inloggegevens.";

const pbsSyncVariantDescription = `

**Tuxis PBS**
De datastore die u wilt synchroniseren is een Tuxis PBS datastore.

**Remote PBS**
De datastore die u wilt synchroniseren staat op een PBS op een andere locatie.`;

const form = {
	// PBS ALERT
	pbs_alert: {
		alert_pruning: {
			label: "(Optioneel) Stuur ook een e-mail bij foutmeldingen over pruning",
			tip: "Pruning is een configureerbare taak van een PBS om oude snapshots op te ruimen. Wanneer een foutmelding optreed tijdens een pruning job, wordt deze foutmelding alleen gemaild naar het e-mailadres voor PBS foutmeldingen wanneer deze checkbox is aangevinkt.",
		},
		description:
			"Geef een e-mailadres op waar u de PBS foutmeldingen op wilt ontvangen en kies optioneel een relatie waar u dit account aan wilt koppelen. Het koppelen van een relatie heeft verder geen invloed op de werking. U kunt ook andere producten aan een relatie koppelen en zo zien wat een relatie allemaal gebruikt",
		pbs_error_email_address: {
			helper_text: {
				business_debtor: {
					href: "/company?scroll_to_communication_preferences=true",
					text: "Naar het bovenstaande e-mailadres worden de PBS foutmeldingen gemaild. U kunt dit e-mailadres aanpassen <a>op de bedrijfsgegevens pagina</a>",
				},
				private_debtor: {
					href: "/account",
					text: "Naar het bovenstaande e-mailadres worden de PBS foutmeldingen gemaild. U kunt dit e-mailadres aanpassen <a>op de accountgegevens pagina</a>",
				},
			},
			label: "E-mailadres voor PBS foutmeldingen",
			placeholder: "Bijvoorbeeld foutmeldingen@example.nl",
		},
		relation: {
			label: "Koppelen aan relatie",
			option: "Koppel PBS aan een relatie",
		},
		title: "Overige informatie",
	},

	// PBS DATASTORE
	pbs_datastore: {
		datastore_alert: {
			alert_option_auto_expand:
				"Stuur een notificatie per e-mail wanneer de datastore <strong>meer dan {{value}}</strong> bevat.",
			alert_option_limited_size:
				"Stuur mij een waarschuwingsmail wanneer de datastore <strong>minder dan {{value}}</strong> vrije ruimte heeft.",
			label: "Notificaties instellen",
		},
		datastore_config: {
			alert_email_address: {
				helper_text:
					"Stuur een e-mail naar dit adres bij de hierboven ingestelde notificatie meldingen.",
				label: "E-mailadres voor notificaties",
				placeholder: "Bijvoorbeeld something@domainname.nl",
			},
			auto_expand: {
				label: "Grow as you go",
				tip: "Deze optie is alleen te gebruiken bij een betaalde pbs. Uw datastore is niet gelimiteerd maar groeit automatisch wanneer deze bijna vol is. U krijgt alleen daadwerkelijk gebruik gefactureerd afgerond naar boven op hele TB's. Het formaat van de datastore is niet relevant voor facturatie.",
			},
			free_version: {
				title: "Datastore uitvoering",
				value: "PBS Gratis - 150 GB",
			},
			label: "Datastore configuratie",
			limited_size: {
				label: "Datastore vast limiet",
				tip: "Uw datastore groeit niet automatisch en kan dus vol raken wanneer u niet tijdig vergroot. U kunt notificaties instellen om dit te voorkomen. U krijgt het daadwerkelijk gebruik gefactureerd afgerond op hele TB's. Het datastore limiet is niet relevant voor facturatie.",
			},
		},

		datastore_info: {
			description: {
				placeholder: "Optionele omschrijving",
			},
			label: "PBS datastore info",
			name: {
				helper_text: "Geef de datastore een passende naam",
				placeholder: "Bijvoorbeeld 'productie'",
			},
		},
		datastore_limit: {
			alert_info_free: "Bij een gratis PBS account kan de limiet niet aangepast worden.",
			alert_info_paid:
				"Uw facturatie is gebaseerd op werkelijk gebruik, afgerond naar de  eerstvolgende terabyte. Met uw huidige limiet wordt nooit meer dan <strong>{{value}}</strong> gefactureerd.",
			label: "Datastore limiet instellen",
		},
		description: pbsConfigDescription,
		title: { pbs: "Configuratie", pbs_sync: "doel destination PBS" },
	},

	// PBS LOCATION
	pbs_location: {
		description:
			"U kunt hier kiezen in welk land en stad uw data wordt bewaard. Zo kunt u zorgen dat uw back-up op een grote afstand van uw live data staat.",
		no_locations:
			"Op dit moment is er geen capaciteit beschikbaar, deze wordt momenteel uitgebreid. Volg ons voor status updates op de [Announcements Pagina](https://support.tuxis.nl/nl/announcements) of op [LinkedIn](https://nl.linkedin.com/company/tuxis-internet-engineering).",
		no_locations_free: "In dit land kan er op dit moment geen gratis PBS afgenomen worden.",
		no_locations_paid: "In dit land kan er op dit moment geen betaalde PBS afgenomen worden.",
		select_country: "Selecteer een land",
		select_invalid: "Selecteer een geldige PBS serverlocatie",
		select_location: "Selecteer een serverlocatie",
		source_and_destination_location_identical:
			"Het is niet toegestaan om een PBS-synchronisatie te configureren op dezelfde locatie als de bron PBS",
		title: {
			pbs: "PBS-serverlocatie",
			pbs_sync: "Locatie doel PBS",
		},
	},

	// PBS RESELLER (USING PBS ALERT TEXT FOR MOST COMPONENTS)
	pbs_reseller: {
		description:
			"Geef een e-mailadres op waar u de PBS foutmeldingen op wilt ontvangen en kies optioneel een relatie waar u dit account aan wilt koppelen. Het koppelen van een relatie heeft verder geen invloed op de werking. U kunt ook andere producten aan een relatie koppelen en zo zien wat een relatie allemaal gebruikt",
		relation: {
			info: "Indien de relatie nog geen inloggegevens heeft op de geselecteerde PBS locatie zijn de inloggegevens 30 dagen zichtbaar in de wachtwoordkluis.",
		},

		reseller_mode: {
			info: pbsResellerDescription,
			option_list: ["Eigen gebruik", "Voor een klant"],
			title: "Datastore aanmaken voor",
		},
		title: "Reseller instellingen",
	},

	// PBS SOURCE SELECTOR
	pbs_source_selector: {
		autocomplete: {
			helper_text: "Gratis datastores zijn uitgesloten van selectie",
			label: "PBS",
			placeholder: "Bestaande datastore selecteren",
			title: "Selecteer een van uw bestaande datastores",
		},
		description: "Selecteer de datastore die u wilt synchroniseren.",
		title: "Bron datastore selecteren",
	},

	// PBS REMOTE SOURCE SELECTOR
	pbs_source_selector_remote: {
		description: "Configureer de bron PBS waarvandaan u wilt synchroniseren.",

		// REMOTE HOST
		remote_host: {
			host: {
				label: "Remote hostname",
				placeholder: "Bijvoorbeeld 'pbs.example.com'",
			},
			port: {
				label: "Remote PBS port",
				placeholder: "Bijvoorbeeld '8007'",
			},
			source_datastore_name: {
				label: "Datastore naam",
				placeholder: "Bijvoorbeeld 'datastore_remote'",
			},
			title: "Remote configureren",
		},

		// REMOTE HOST CREDENTIALS
		remote_host_credentials: {
			title: "Remote host authenticatie",
			token_name: {
				label: "Token naam",
				placeholder: "Geef de token naam op",
			},
			token_secret: {
				label: "Token secret",
				placeholder: "Geef de token secret op",
			},
			user_name: {
				label: "Gebruikersnaam",
				placeholder: "Bijvoorbeeld 'voorbeeld@pbs'",
			},
		},

		// FINGER PRINT
		ssl_fingerprint: {
			checkbox: {
				label: "De PBS host maakt gebruik van een self-signed certificate",
				tooltip:
					"De SSL-fingerprint wordt gecontroleerd bij het opzetten van een beveiligde verbinding. Bij een self-signed certificaat is dit een verplicht veld, bij een officieel certificaat is het optioneel. [Lees meer.](https://pbs.proxmox.com/docs/sysadmin.html#certificate-management)",
			},
			ssl_fingerprint: {
				placeholder: "Geef SSL-fingerprint op",
			},
			title: "SSL fingerprint",
		},

		// BUTTONS
		test_button: "Verbinding testen",
		test_success: "Verbinding succesvol getest",
		test_tooltip:
			"Dit is een optionele test. Deze test gaat uw ingevulde Informatie testen om er meer zeker van te zijn dat u uw informatie juist heeft ingevuld. \n Het kan zijn dat deze test niet werkt als u een whitelist heeft staan op uw host. Wel kan u dan gewoon een pbs-sync aanmaken.",
		title: "Bron PBS informatie",
	},

	// PBS SYNC VARIANT
	pbs_sync_variant: {
		description: pbsSyncVariantDescription,
		option_list: {
			remote_pbs: "Remote PBS",
			tuxis_pbs: "Tuxis PBS",
		},
		title: "Bron PBS",
	},
	// PBS TYPE
	pbs_type: {
		description:
			"De gratis versie is beschikbaar voor iedereen. Alleen Bedrijven en Nederlandse particulieren kunnen de betaalde versie afnemen.",
		title: "Tuxis PBS uitvoering",
	},

	// PBS SYNC INTERVAL
	schedule: {
		description: "Geef aan hoe vaak u de datastore wilt synchroniseren naar de doel-datastore.",
		option_list: {
			day_1: "1 keer per dag",
			day_4: "4 keer per dag",
			day_12: "12 keer per dag",
		},
		select: {
			helper_text: "Synchronisatie intervallen kunnen bijgewerkt worden.",
			label: "Interval",
			placeholder: "Selecteer een interval",
			title: "Selecteer een interval",
		},
		title: "Synchronisatie interval",
	},

	// SUBMIT SECTION
	submit_button: "Configuratie controleren",
};

/* -------------------------------------------------------------------------- */
/*                                CONFIRM PAGE                                */
/* -------------------------------------------------------------------------- */
const confirm = {
	config: {
		alert_email_address: "Notificatie e-mailadres:",
		alert_info:
			"We berekenen de hoogste opslagpiek die gedurende de maand is gemeten en ronden deze naar boven af op een hele terabyte.",
		alert_send_by: {
			label: "Notificaties sturen bij",
			list: [
				"Fouten opgemerkt door Proxmox Backup Server",
				"Indien <strong>{{value}}</strong> aan opslag resterend",
				"Indien <strong>{{value}}</strong> aan opslag is bereikt",
				"Foutmeldingen bij Pruning",
			],
		},
		datastore_config: "Datastore configuratie:",
		description: "Bekijk hier het overzicht van de PBS die u gaat bestellen",
		fingerprint: "SSL-fingerprint",
		host: "Remote PBS hostname",
		location: "PBS Serverlocatie:",
		pbs_source_selector: "Geselecteerde Tuxis PBS",
		pbs_sync_variant: "Bron PBS",
		pbs_type: "PBS uitvoering:",
		port: "Remote PBS port",
		price_discount: "Uw korting",
		price_exc_vat: "Exc. BTW",
		price_line_pbs: "Per terabyte €{{value}} p/m",
		price_line_pbs_sync: "€{{value}} p/m",
		price_pbs: "Prijs PBS:",
		price_pbs_sync: "Prijs PBS sync",
		relation: "Gekoppelde relatie:",
		schedule: "Synchronisatie interval",
		source_datastore_name: "Remote datastore name",
		title: "Configuratie overzicht",
		token_name: "Token naam",
		token_secret: "Token secret",
		user_name: "Gebruikersnaam",
	},

	info: {
		description: {
			label: "Omschrijving (optioneel)",
			placeholder: "Optionele omschrijving",
		},
		name: {
			label: "Datastore naam",
			placeholder: "Bijvoorbeeld 'productie'",
		},
		purchase_order_number: {
			helper:
				"Wanneer u een inkoopordernummer invult, wordt deze dienst altijd apart gefactureerd en wordt het inkoopordernummer op de factuur vermeld.",
			label: "Orderinkoopnummer (optioneel)",
			placeholder: "Bijvoorbeeld '1-2344-3949-3'",
		},
		text: "Pas hier nog eventuele PBS gegevens aan.",
		title: "PBS details",
	},

	product_details: {
		pbs: "Proxmox Backup Service",
		pbs_edit: "Proxmox Backup Service - Bijwerken",
		pbs_free: "Proxmox Backup Service - Gratis (150GB)",
		pbs_sync: "PBS sync",
		pbs_sync_edit: "PBS sync - Bijwerken",
		title: "Product overzicht",
	},
	status_messages: {
		no_nodes_available:
			"Helaas is er op dit moment geen capaciteit op de locatie aanwezig. Probeer een andere locatie of neem contact op met support.",
		success:
			"Uw nieuwe PBS is succesvol aangemaakt! De inloggegevens zijn te vinden in de wachtwoordkluis.",
	},
	title: "Besteloverzicht",
};

const create = {
	confirm: confirm,
	form: form,
	select_type: selectType,
	titles: titles,
};

export default create;
